import PropTypes from 'prop-types';

export const libraryShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  created_by: PropTypes.string,
  calls_count: PropTypes.number,
  modified: PropTypes.string,
  shared_type: PropTypes.string,
});
